import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireMessagingModule, VAPID_KEY} from '@angular/fire/compat/messaging';
import {AngularFireModule} from '@angular/fire/compat';
import { ModalStatusAppPageModule } from './shared/modals/modal-status-app/modal-status-app.module';
import {ModalAtualizacaoAppPageModule} from './shared/modals/modal-atualizacao-app/modal-atualizacao-app.module';
import {Market} from '@awesome-cordova-plugins/market/ngx';

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    ModalStatusAppPageModule,
    ModalAtualizacaoAppPageModule,
    IonicStorageModule.forRoot(), // colocar o nome do storage
    IonicModule.forRoot({mode: 'md'}),
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    BrowserAnimationsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
  ],
  providers: [
    Geolocation,
    SocialSharing,
    AppVersion,
    Market,
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: VAPID_KEY, useValue: (environment.firebaseConfig as any).vapidKey}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
